module.exports = __webpack_public_path__ + "static/media/4_4.b988aecc.png";